import { scrapeNode } from "./scrapeNode";

/**
 * What a toast says, on one line. `.Toastify__toast-body` holds the message alone — the close
 * button and the progress bar are its siblings — so this is the sentence the user was shown,
 * carrying any link or button inside it.
 *
 * Both halves of `readToasts` go through here: the toasts on screen now, and the recording
 * `makeToast` takes as a toast opens so the message survives its auto-close. Reading them the
 * same way is what lets an entry that outlived its toast dedupe against the live one.
 */
export const readToastText = (toast: HTMLElement, shouldSkipBlockedInFullstory: boolean): string => {
  const body = toast.querySelector(".Toastify__toast-body");
  return scrapeNode(body instanceof HTMLElement ? body : toast, shouldSkipBlockedInFullstory)
    .content.replace(/\n+/g, " ")
    .trim();
};
